import {
  generators,
  UninstallRedirect,
  UninstallOrganizationRequest,
} from './generators';
import { APIResult } from 'utils/apidata';
import { call, put } from 'redux-saga/effects';
import { navigate } from 'reducers/Navigation';

export function* handleUninstallRedirect(
  request: UninstallOrganizationRequest,
  response: APIResult<UninstallRedirect>
) {
  if (response.success) {
    yield put(navigate({ href: response.data.url }));
  } else {
    yield put(navigate({ href: '/dash' }));
  }
}

export const uninstallOrganization = generators.uninstallOrganization.saga(
  (api, { provider, providerId, organizationType }) =>
    call(api.del, `/api/v1/${provider}/install`, {
      provider_id: providerId,
      type: organizationType,
    }),
  handleUninstallRedirect
);

export function* sagas() {
  yield uninstallOrganization;
}
